import type { DateInput } from '@fourthwall/utils/dist/timezone'
import { toDayjs } from '@fourthwall/utils/dist/timezone'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from 'dayjs/plugin/utc'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import React from 'react'

dayjs.extend(weekOfYear)
dayjs.extend(advancedFormat)
dayjs.extend(utc)

export type DateStringProps = {
  date: DateInput
  format?: string
  utc?: boolean
}

export const DateString = ({ date, format = 'DD MMM YYYY', utc = false }: DateStringProps) => {
  let day = toDayjs(date)

  if (!day.isValid()) {
    return null
  }

  if (utc) {
    day = day.utc()
  }

  return <time dateTime={day.toISOString()}>{day.format(format)}</time>
}
